import React, { Component } from "react";
import CountryDropdown from "../CommonComponent/CountryDropdown";
import {
  Input,
  Label,
  Alert,
  Tooltip,
  GlyphInfo,
  TooltipButton,
  RadioGroup,
  Hint,
  RadioButton,
  ButtonPrimary,
} from "@americanexpress/dls-react";
import "./AddAccessStyle.css";
import { withTranslation } from "react-i18next";
import Upload from "../Import/Upload";
import PaymentForm from "./paymentform";
import { COUNTRY_CODE_PREFIX } from "../Common/constants";
import { isSwedenNorway } from "../Common/utils";

class AddAccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      country: "",
      accessesArray: [],
      userAccess: [],
      selectedFunctions: [],
      selectedRoles: [],
      corporateId: "",
      isValid: false,
      upload: false,
      invalidAccess: false,
      invalidAccessOptions: false, // for Add/Delete validation
      invalidCountry: false,
      fileArr: [],
      checked: false,
      invalidMmid: false,
      invalidBta: false,
      invalidccdNumber: false,
      invalidcsdNumber: false,
      invalidcorporateMembershipRewards: false,
      invalidPaymentForm: false,
      isWorkrole: false,
      isOnlineRole: false,
      isCorpRole: false,
      isVpaymentRole: false,
      idInvalid: false,
      actionName: [],
      savObj: {
        paymentData: {},
        mmid: "",
        bta: "",
        message: "",
        ccdNumber: "",
        csdNumber: "",
        corporateMembershipRewards: "",
      },
      error: false,
      submit: false,
      fundingBillingAccount: "",
      saveCountry: "",
      outerCheckbox: "",
      innerCheckbox: "",
      // saveFunction: false,
      // saveRolename: false,
      // saveFileLength: false,
    };
  }

  componentDidMount(prevProps) {
    if (this.props.accessobj.country !== undefined) {
      const selectedAccess = this.props.accesses.filter(
        (acc) => acc.country === this.props.accessobj.country
      );
      this.props.getValue(true);

      let selroles = [];
      this.props.accessobj.functions.map((fun) => {
        if (fun.roles.length > 0) {
          fun.roles.map((item) =>
            selroles.push({
              functionName: fun.functionName,
              roleName: item.roleName,
            })
          );
        }
        return 0;
      });
      this.setState(
        {
          edit: true,
          accessesArray: selectedAccess,
          country: selectedAccess[0].country,
          corporateId: this.props.accessobj.controlAccountNumber,
          selectedFunctions: this.props.accessobj.functions,
          selectedRoles: selroles,
          invalidCountry: false,
          invalidCorporatedId: false,
        },
        () => {}
      );
    }
  }

  /** This function will be called on change of country value */
  handleSelectChange = (key, value) => {
    const { t } = this.props;
    this.setState({ saveCountry: value });
    const selectedAccess = this.props.accesses.filter(
      (acc) => acc.country === value
    );
    if (selectedAccess[0].country === t("access.INDIA")) {
      this.setState({ upload: true });
    } else {
      this.setState({ upload: false });
    }
    if (selectedAccess[0].country === t("access.JAPAN")) {
      this.setState({ corporateId: "010" });
    }

    this.props.getValue(true);

    this.setState({
      accessesArray: selectedAccess,
      country: selectedAccess[0].country,
      corporateId: "",
      fundingBillingAccount: "",
      selectedFunctions: [],
      selectedRoles: [],
      invalidCountry: false,
      invalidCorporatedId: false,
      edit: false,
    });

  };

  /** This function will be called on change of checkbox */
  checkBoxHandler = (event) => {
    const { selectedFunctions, actionName, selectedRoles, savObj } = this.state;
    let selectedArray = selectedFunctions;
    if (event.target.checked) {
      selectedArray.push({ functionName: event.target.name + "", roles: [] });
      this.setState({ outerCheckbox: event.target.name });
    } else {
      let index = selectedArray
        .map((item) => item.functionName)
        .indexOf(event.target.name + "");
      if (index > -1) {
        selectedArray.splice(index, 1);
      }
      this.setState({
        actionName: actionName.filter(
          (f) => f.functionName !== event.target.name
        ),
      });
    }
    this.setState({ selectedFunctions: selectedArray });

    this.setState({
      selectedRoles: selectedRoles.filter(
        (frole) => frole.functionName !== event.target.name
      ),
    });

    let functArray = selectedFunctions;
    const { t } = this.props;
    functArray.map((farray) => {
      if (
        farray.functionName === t("products.functname10") &&
        farray.roles.length === 0
      ) {
        this.setState({ isWorkrole: true });
      }
      if (
        farray.functionName === t("products.functname2") &&
        farray.roles.length === 0
      ) {
        this.setState({ isOnlineRole: true });
      }
      if (
        farray.functionName === t("products.functname4") &&
        farray.roles.length === 0 &&
        savObj.mmid.length !== 12
      ) {
        if (
          this.functionSorting(t("products.functname4"))
            ?.membershipRewardsAccountNumber?.length === 12
        ) {
          this.setState({ invalidMmid: false });
        } else {
          this.setState({ isCorpRole: true, invalidMmid: true });
        }
      } else {
        this.setState({ invalidMmid: false });
      }

      // New Fix
      if (
        farray.functionName === t("products.functname5") &&
        savObj.bta.length !== 10
      ) {
        if (
          this.functionSorting(t("products.functname5"))?.btaNumber?.length ===
          10
        ) {
          this.setState({ invalidBta: false });
        } else {
          this.setState({ invalidBta: true });
        }
      } else {
        this.setState({ invalidBta: false });
      }

      // Central Card Delivery
      if (
        farray.functionName === t("ukFunction.function4") &&
        savObj.ccdNumber.length !== 15
      ) {
        if (
          this.functionSorting(t("ukFunction.function4"))?.ccdNumber?.length ===
          15
        ) {
          this.setState({ invalidccdNumber: false });
        } else {
          this.setState({ invalidccdNumber: true });
        }
      } else {
        this.setState({ invalidccdNumber: false });
      }

      // Central Statement Delivery
      if (
        farray.functionName === t("ukFunction.function5") &&
        savObj.csdNumber.length !== 15
      ) {
        if (
          this.functionSorting(t("ukFunction.function5"))?.csdNumber?.length ===
          15
        ) {
          this.setState({ invalidcsdNumber: false });
        } else {
          this.setState({ invalidcsdNumber: true });
        }
      } else {
        this.setState({ invalidcsdNumber: false });
      }

      // Corporate Membership Rewards
      if (
        farray.functionName === t("ukFunction.function6") &&
        savObj.corporateMembershipRewards.length !== 15
      ) {
        if (
          this.functionSorting(t("ukFunction.function6"))
            ?.corporateMembershipRewards?.length === 15
        ) {
          this.setState({ invalidcorporateMembershipRewards: false });
        } else {
          this.setState({ invalidcorporateMembershipRewards: true });
        }
      } else {
        this.setState({ invalidcorporateMembershipRewards: false });
      }

      if (
        farray.functionName === t("products.functname9") &&
        farray.roles.length === 0
      ) {
        this.setState({ isVpaymentRole: true });
      }
    });
  };

  /**
   * This function will be called on the selection of
   * Add/Delete radio button in modify journey
   */
  handleRadioClick = (event, fName) => {
    // filter all function names except the selected one and update the state
    const fList = this.state.actionName.filter(
      (item) => item.functionName !== fName
    );
    this.setState({
      actionName: [
        ...fList,
        { functionName: fName, actionName: event.target.value },
      ],
    });
  };

  /**
   * This function will be called when you select any
   * role related checkbox under each function
   */
  handleRoleClick = (event, functionName) => {
    const { selectedRoles, selectedFunctions, savObj } = this.state;
    let selectedRoleArray = selectedRoles;
    let roleArray = selectedFunctions;
    let roles = [];
    const { t } = this.props;
    if (event.target.checked) {
      this.setState({ innerCheckbox: event.target.name });
      if (functionName === t("products.functname9")) {
        let index = null;
        if (event.target.name === t("products.pafull")) {
          index = selectedRoleArray
            .map((item) => item.roleName)
            .indexOf(t("products.pacom"));
          roles = roleArray.map((item) => {
            return {
              ...item,
              roles: item.roles.filter(
                (rol) => rol.roleName !== t("products.pacom")
              ),
            };
          });
          roleArray = roles;
        } else {
          index = selectedRoleArray
            .map((item) => item.roleName)
            .indexOf(t("products.pafull"));
          roles = roleArray.map((item) => {
            return {
              ...item,
              roles: item.roles.filter(
                (rol) => rol.roleName !== t("products.pafull")
              ),
            };
          });
          roleArray = roles;
        }

        if (index > -1) {
          selectedRoleArray.splice(index, 1);
        }
      }
      if (functionName === t("products.functname4")) {
        let index = null;
        if (event.target.name === t("products.cmrpa")) {
          index = selectedRoleArray
            .map((item) => item.roleName)
            .indexOf(t("products.3pa"));
          roles = roleArray.map((item) => {
            return {
              ...item,
              roles: item.roles.filter(
                (rol) => rol.roleName !== t("products.3pa")
              ),
            };
          });
          roleArray = roles;
        } else {
          index = selectedRoleArray
            .map((item) => item.roleName)
            .indexOf(t("products.cmrpa"));
          roles = roleArray.map((item) => {
            return {
              ...item,
              roles: item.roles.filter(
                (rol) => rol.roleName !== t("products.cmrpa")
              ),
            };
          });
          roleArray = roles;
        }

        if (index > -1) {
          selectedRoleArray.splice(index, 1);
        }
      }
      if (functionName === t("products.functname2")) {
        let index = null;
        if (event.target.name === t("products.role-approver")) {
          index = selectedRoleArray
            .map((item) => item.roleName)
            .indexOf(t("products.role-initiator"));
          roles = roleArray.map((item) => {
            return {
              ...item,
              roles: item.roles.filter(
                (rol) => rol.roleName !== t("products.role-initiator")
              ),
            };
          });
          roleArray = roles;
        } else {
          index = selectedRoleArray
            .map((item) => item.roleName)
            .indexOf(t("products.role-approver"));
          roles = roleArray.map((item) => {
            return {
              ...item,
              roles: item.roles.filter(
                (rol) => rol.roleName !== t("products.role-approver")
              ),
            };
          });
          roleArray = roles;
        }
        if (index > -1) {
          selectedRoleArray.splice(index, 1);
        }
      }

      selectedRoleArray.push({
        functionName: functionName,
        roleName: event.target.name + "",
      });

      roleArray.map((funcs) => {
        let rolesArr = funcs.roles;
        if (funcs.functionName === functionName) {
          let formatRoles = {
            roleName: event.target.name,
            mmid: savObj.mmid,
            docNames: "document",
          };
          rolesArr.push(formatRoles);
        }
        const { t } = this.props;
        roleArray.map((frolarray) => {
          if (
            frolarray.functionName === t("products.functname10") &&
            frolarray.roles.length > 0
          ) {
            this.setState({ isWorkrole: false });
          }
          if (
            frolarray.functionName === t("products.functname2") &&
            frolarray.roles.length > 0
          ) {
            this.setState({ isOnlineRole: false });
          }
          if (
            frolarray.functionName === t("products.functname4") &&
            frolarray.roles.length > 0
          ) {
            this.setState({ isCorpRole: false });
          }
          if (
            frolarray.functionName === t("products.functname9") &&
            frolarray.roles.length > 0
          ) {
            this.setState({ isVpaymentRole: false });
          }
        });

        funcs.roles = rolesArr;
        return rolesArr;
      });
    } else {
      let index = selectedRoleArray
        .map((item) => item.roleName)
        .indexOf(event.target.name + "");
      if (index > -1) {
        selectedRoleArray.splice(index, 1);
      }
      roles = roleArray.map((item) => {
        return {
          ...item,
          roles: item.roles.filter((rol) => rol.roleName !== event.target.name),
        };
      });
      roleArray = roles;
      const { t } = this.props;
      roleArray.map((frolarray) => {
        if (
          frolarray.functionName === t("products.functname10") &&
          frolarray.roles.length === 0
        ) {
          this.setState({ isWorkrole: true });
        }
        if (
          frolarray.functionName === t("products.functname2") &&
          frolarray.roles.length === 0
        ) {
          this.setState({ isOnlineRole: true });
        }
        if (
          frolarray.functionName === t("products.functname4") &&
          frolarray.roles.length === 0
        ) {
          this.setState({ isCorpRole: true });
        }
        if (
          frolarray.functionName === t("products.functname9") &&
          frolarray.roles.length === 0
        ) {
          this.setState({ isVpaymentRole: true });
        }
      });
    }
    this.setState({ selectedFunctions: roleArray });
    this.setState({ selectedRoles: selectedRoleArray });

    if (selectedRoles && selectedRoles.indexOf(selectedRoles) + 1 >= 0) {
      this.setState({ error: false, isroleselected: false });
    }
  };

  /**
   * This function will be used for checking the validation for vpayment and goexpress
   *  functions fields after we click on view/edit of each access
   */
  formEmptyCheck = (value) => {
    const { t } = this.props;
    let data = this.state?.selectedFunctions?.filter((e) => {
      if (e?.functionName === value) {
        if (
          e.dailyNumberOfTokens !== undefined &&
          e.fundingBillingAccount !== undefined &&
          e.maxLimitPerToken !== undefined &&
          e.maxSpendPerDay !== undefined &&
          e.notificationRecipient !== undefined &&
          e.thresholdAmount !== undefined
        ) {
          return true;
        }
      }
    });
    return data[0];
  };

  /** This function will be called when we click on save access button for saving
   * the added accesses
   */
  handleAddAccess = () => {
    const { t } = this.props;

    const {
      selectedFunctions,
      // saveFunction,
      // saveRolename,
      // saveFileLength,
      fileArr,
      saveCountry,
      outerCheckbox,
      innerCheckbox,
      // country,
      invalidMmid,
      invalidBta,
      invalidccdNumber,
      invalidcsdNumber,
      invalidcorporateMembershipRewards,
      invalidPaymentForm,
      savObj,
      userAccess,
      accessesArray,
      corporateId,
      actionName,
      isValid,
    } = this.state;

    // selectedFunctions.map((e) =>
    //   e?.functionName === t("products.functname2")
    //     ? (this.state.saveFunction = true)
    //     : (this.state.saveFunction = false)
    // );

    // selectedFunctions.map((e) =>
    //   e?.roles.map((val) =>
    //     val?.roleName === t("products.role-approver")
    //       ? (this.state.saveRolename = true)
    //       : (this.state.saveRolename = false)
    //   )
    // );

    // selectedFunctions.map((e) =>
    //   e?.roles.map((val) =>
    //     val?.files?.length === 0
    //       ? (this.state.saveFileLength = true)
    //       : (this.state.saveFileLength = false)
    //   )
    // );

    if (
      fileArr.length === 0 &&
      saveCountry === t("access.INDIA") &&
      outerCheckbox === t("products.functname2") &&
      innerCheckbox === t("products.role-approver")
    ) {
      return false;
    }
    // else if (
    //   country === t("access.INDIA") &&
    //   saveFunction &&
    //   saveRolename &&
    //   saveFileLength
    // ) {
    //   console.log("india disable");
    // }
    else {
      const vpay = t("products.functname9");
      const amexGo = t("products.functname12");
      const cmr = t("products.functname4");
      const accessEdit =
        this.props.accessobj.country !== undefined ? true : false;
      this.setState({ edit: false, submit: true });
      this.validateAccess();

      let showVpayment =
        selectedFunctions
          .map((item) => item.functionName)
          .indexOf(t("products.functname9")) > -1
          ? true
          : false;

      let showExpressGo =
        selectedFunctions
          .map((item) => item.functionName)
          .indexOf(t("products.functname12")) > -1
          ? true
          : false;

      if (
        !invalidMmid &&
        !invalidBta &&
        !invalidccdNumber &&
        !invalidcsdNumber &&
        !invalidcorporateMembershipRewards &&
        !invalidPaymentForm &&
        (showVpayment
          ? (savObj.paymentData?.vPayment !== undefined &&
              Object.keys(savObj.paymentData?.vPayment).length !== 0) ||
            this.formEmptyCheck(t("products.functname9"))
          : true) &&
        (showExpressGo
          ? (savObj.paymentData?.goExpress !== undefined &&
              Object.keys(savObj.paymentData?.goExpress).length !== 0) ||
            this.formEmptyCheck(t("products.functname12"))
          : true)
      ) {
        let access = userAccess;
        if (accessesArray.length && corporateId.length) {
          if (selectedFunctions.length) {
            // to check any of the Add/Delete options are not opted for any selected funcitons
            if (
              this.props.modifyUser &&
              selectedFunctions.length !== actionName.length
            ) {
              this.setState({ invalidAccessOptions: true });
            } else {
              const newObj = {
                country: accessesArray[0].country,
                controlAccountNumber: corporateId.replace(/\s+/g, ""),
                functions: selectedFunctions.map((fnc) => {
                  return {
                    functionName: fnc.functionName,
                    btaNumber:
                      fnc.functionName === t("products.functname5")
                        ? savObj.bta ||
                          this.functionSorting(t("products.functname5"))
                            ?.btaNumber
                        : "",
                    membershipRewardsAccountNumber:
                      fnc.functionName === cmr
                        ? savObj.mmid ||
                          this.functionSorting(t("products.functname4"))
                            ?.membershipRewardsAccountNumber
                        : "",
                    docName: "",
                    roles: fnc.roles,
                    fundingBillingAccount:
                      fnc.functionName === vpay
                        ? savObj.paymentData?.vPayment?.fundingAcc ||
                          fnc.fundingBillingAccount
                        : fnc.functionName === amexGo
                        ? savObj.paymentData?.goExpress?.fundingAcc ||
                          fnc.fundingBillingAccount
                        : "",
                    maxLimitPerToken:
                      fnc.functionName === vpay
                        ? savObj.paymentData?.vPayment?.maxToken ||
                          fnc.maxLimitPerToken
                        : fnc.functionName === amexGo
                        ? savObj.paymentData?.goExpress?.maxToken ||
                          fnc.maxLimitPerToken
                        : "",
                    dailyNumberOfTokens:
                      fnc.functionName === vpay
                        ? savObj.paymentData?.vPayment?.dailyToken ||
                          fnc.dailyNumberOfTokens
                        : fnc.functionName === amexGo
                        ? savObj.paymentData?.goExpress?.dailyToken ||
                          fnc.dailyNumberOfTokens
                        : "",
                    maxSpendPerDay:
                      fnc.functionName === vpay
                        ? savObj.paymentData?.vPayment?.maxSpend ||
                          fnc.maxSpendPerDay
                        : fnc.functionName === amexGo
                        ? savObj.paymentData?.goExpress?.maxSpend ||
                          fnc.maxSpendPerDay
                        : "",
                    thresholdAmount:
                      fnc.functionName === vpay
                        ? savObj.paymentData?.vPayment?.thresholdAmount ||
                          fnc.thresholdAmount
                        : fnc.functionName === amexGo
                        ? savObj.paymentData?.goExpress?.thresholdAmount ||
                          fnc.thresholdAmount
                        : "",
                    notificationRecipient:
                      fnc.functionName === vpay
                        ? savObj.paymentData?.vPayment?.recepient ||
                          fnc.notificationRecipient
                        : fnc.functionName === amexGo
                        ? savObj.paymentData?.goExpress?.recepient ||
                          fnc.notificationRecipient
                        : "",
                    ccdNumber:
                      fnc.functionName === t("ukFunction.function4")
                        ? savObj.ccdNumber ||
                          this.functionSorting(t("ukFunction.function4"))
                            ?.ccdNumber
                        : "",
                    csdNumber:
                      fnc.functionName === t("ukFunction.function5")
                        ? savObj.csdNumber ||
                          this.functionSorting(t("ukFunction.function5"))
                            ?.csdNumber
                        : "",
                    corporateMembershipRewards:
                      fnc.functionName === t("ukFunction.function6")
                        ? savObj.corporateMembershipRewards ||
                          this.functionSorting(t("ukFunction.function6"))
                            ?.corporateMembershipRewards
                        : "",
                  };
                }),
              };
              if (!isValid) {
                access.push(newObj);
                let validRolesSelect = true;
                if (newObj.functions.length > 0) {
                  const { t } = this.props;
                  newObj.functions.map((fname) => {
                    if (
                      fname.functionName === t("products.functname10") ||
                      fname.functionName === t("products.functname2") ||
                      fname.functionName === t("products.functname4") ||
                      fname.functionName === t("products.functname9")
                    ) {
                      if (fname.roles.length === 0) {
                        validRolesSelect = false;
                      }
                      if (
                        fname.functionName === t("products.funcname5") &&
                        savObj.bta.length !== 10
                      ) {
                        validRolesSelect = false;
                      }
                    }
                  });
                }
                if (this.props.modifyUser) {
                  newObj.functions.map((fname) => {
                    let action = "";
                    // get the value Add/Delete for each functions from state
                    if (actionName.length > 0) {
                      action = actionName.filter(
                        (f) => f.functionName === fname["functionName"]
                      )[0].actionName;
                    }
                    fname["actionName"] = action;
                  });
                }
                if (
                  validRolesSelect &&
                  corporateId.replace(/\s+/g, "").match(/^[0-9]*$/)
                ) {
                  this.setState({ userAccess: access });
                  this.clearFields();
                  this.props.getAccess(newObj, accessEdit);

                  this.setState({ submit: false });
                  this.props.getValue(false);
                }
              }
            }
          } else {
            this.setState({ invalidAccess: true });
          }
        }
      }
    }
  };

  /** This function will be used for checking the length of coutry and corporate fields */
  validateAccess = () => {
    const { country, corporateId } = this.state;
    if (country === "") {
      this.setState({ invalidCountry: true });
    }
    if (corporateId === "") {
      this.setState({ invalidCorporatedId: true });
    }
  };

  /**
   * This function will be used for clearing/resetting
   * the fields values after saving the access
   */
  clearFields = () => {
    let savObjClone = {
      paymentData: {},
      mmid: "",
      bta: "",
    };
    this.setState({
      country: "",
      accessesArray: [],
      selectedFunctions: [],
      selectedRoles: [],
      fileArr: [],
      corporateId: "",
      isValid: false,
      upload: false,
      savObj: savObjClone,
      invalidMmid: false,
      invalidBta: false,
      invalidPaymentForm: false,
      invalidRecepient: false,
      invalidAccess: false,
      invalidAccessOptions: false,
      invalidCountry: false,
      invalidCorporatedId: false,
      actionName: [],
      fundingBillingAccount: "",
    });
  };

  /** This function is called when we try to upload a file */
  getFile = (file) => {
    let newArr = [...this.state.selectedFunctions];
    let files = [...this.state.fileArr];
    const { t } = this.props;
    newArr.map((func) => {
      if (func.functionName === t("products.functname2")) {
        func.roles.map((rol) => {
          if (rol.roleName === t("products.role-approver")) {
            files.push(file);
            let fileNames = file.map((item) => item.documentName);
            rol.docNames = fileNames;
            rol.files = file;
            return func.roles;
          }
          return 0;
        });
      }
      return newArr;
    });
    //this.setState({ selectedFunctions: newArr, fileArr: file });
    this.setState({ selectedFunctions: newArr, fileArr: files });
    this.setState({ fileCount: this.state.fileArr.length });
  };

  /** This function will be called on change of Corporate ID value */
  updateCorporateId = (value) => {
    const { t } = this.props;
    const { country, corporateId } = this.state;
    let corporateIdCpy = corporateId;
    if (corporateId.length < 1 && country === t("access.JAPAN")) {
      corporateIdCpy = "010" + value;
    } else {
      corporateIdCpy = value;
    }

    this.setState({ corporateId: corporateIdCpy });
  };

  /**
   * This function will be used for adding prefix value to the entered
   * Corporate ID value on onBlur event of Corporate ID field
   */
  prefixCorporateId = () => {
    let prefix = "";
    const { t } = this.props;
    const { accessesArray, country, corporateId } = this.state;

    switch (accessesArray[0].country) {
      case t("access.AUSTRALIA"):
        prefix = COUNTRY_CODE_PREFIX.AUSTRALIA;
        break;
      case t("access.NEWZEALAND"):
        prefix = COUNTRY_CODE_PREFIX.NEWZEALAND;
        break;
      case t("access.INDIA"):
        prefix = COUNTRY_CODE_PREFIX.INDIA;
        break;
      case t("access.SINGAPORE"):
        prefix = COUNTRY_CODE_PREFIX.SINGAPORE;
        break;
      case t("access.HONGKONG"):
        prefix = COUNTRY_CODE_PREFIX.HONGKONG;
        break;
      case t("access.THAILAND"):
        prefix = COUNTRY_CODE_PREFIX.THAILAND;
        break;
      case t("access.TAIWAN"):
        prefix = COUNTRY_CODE_PREFIX.TAIWAN;
        break;
      case t("access.NORWAY"):
        prefix = COUNTRY_CODE_PREFIX.NORWAY;
        break;
      case t("access.SWEDEN"):
        prefix = COUNTRY_CODE_PREFIX.SWEDEN;
        break;
      case t("access.INTERNATIONALEUROCARD"):
        prefix = COUNTRY_CODE_PREFIX.INTERNATIONALEUROCARD;
        break;
      case t("access.UNITEDKINGDOM"):
        prefix = COUNTRY_CODE_PREFIX.UNITEDKINGDOM;
        break;
      default:
        prefix = "";
    }

    if (corporateId.match(/^[0-9]*$/)) {
      if (country === t("access.JAPAN") && corporateId.length !== 15) {
        this.setState({ isValid: true, idInvalid: true });
      }
      if (
        (country === t("access.UNITEDKINGDOM") || isSwedenNorway(country, t)) &&
        corporateId.length !== 15 &&
        corporateId.length !== 9
      ) {
        this.setState({ isValid: true, idInvalid: true });
      }
      if (
        (country === t("access.UNITEDKINGDOM") || isSwedenNorway(country, t)) &&
        (corporateId.length === 15 || corporateId.length === 9)
      ) {
        if (!corporateId.includes(prefix)) {
          this.setState({ isValid: true, idInvalid: true });
        }
        if (corporateId.includes(prefix)) {
          this.setState({ isValid: false, idInvalid: false });
        }
      }
      if (
        country === t("access.GLOBAL DOLLAR CARD") &&
        corporateId.length !== 15
      ) {
        this.setState({ isValid: true, idInvalid: true });
      }
      if (
        corporateId.length === 6 &&
        country !== t("access.GLOBAL DOLLAR CARD") &&
        country !== t("access.JAPAN") &&
        country !== t("access.UNITEDKINGDOM") &&
        country !== t("access.SWEDEN") &&
        country !== t("access.NORWAY")
      ) {
        let prefixCorporateId = prefix + corporateId;
        this.setState({
          corporateId: prefixCorporateId,
          isValid: false,
          idInvalid: false,
        });
      }
      if (
        (corporateId.length === 6 || corporateId.length === 12) &&
        (country === t("access.UNITEDKINGDOM") || isSwedenNorway(country, t))
      ) {
        let prefixCorporateId = prefix + corporateId;
        this.setState({
          corporateId: prefixCorporateId,
          isValid: false,
          idInvalid: false,
        });
      } else if (
        corporateId.length === 15 &&
        country !== t("access.GLOBAL DOLLAR CARD") &&
        country !== t("access.JAPAN") &&
        country !== t("access.UNITEDKINGDOM") &&
        country !== t("access.SWEDEN") &&
        country !== t("access.NORWAY")
      ) {
        this.setState({ isValid: false, idInvalid: false });
      } else if (
        country !== t("access.GLOBAL DOLLAR CARD") &&
        country !== t("access.JAPAN") &&
        country !== t("access.UNITEDKINGDOM") &&
        country !== t("access.SWEDEN") &&
        country !== t("access.NORWAY") &&
        corporateId.length !== 6
      ) {
        this.setState({ isValid: true, idInvalid: true });
      } else if (
        corporateId.length !== 15 &&
        (country === t("access.GLOBAL DOLLAR CARD") ||
          country === t("access.JAPAN"))
      ) {
        this.setState({ isValid: true, idInvalid: true });
      } else if (corporateId.length === 0) {
        this.setState({ isValid: true });
      } else if (
        corporateId.length < 6 &&
        country !== t("access.GLOBAL DOLLAR CARD") &&
        country !== t("access.JAPAN") &&
        country !== t("access.UNITEDKINGDOM") &&
        country !== t("access.SWEDEN") &&
        country !== t("access.NORWAY")
      ) {
        this.setState({ isValid: false, idInvalid: true });
      }
    }

    if (!corporateId.match(/^[0-9]*$/) && corporateId.length !== 0) {
      this.setState({ isValid: false });
    }
  };

  /** This function will be called on Input onChange event */
  updateSavobj = (key, value) => {
    const { savObj } = this.state;
    savObj[key] = value;
    this.setState({ savObj });
  };

  functionSorting = (value) => {
    let data = this.state?.selectedFunctions?.filter(
      (e) => e?.functionName === value
    );
    return data[0];
  };

  /** This function is used for validating the Input fields values on onBlur event */
  validateDetails = (value) => {
    const { savObj } = this.state;
    if (value === "mmid") {
      if (isNaN(Number(savObj.mmid))) {
        this.setState({ invalidMmid: true, error: true });
      } else if (savObj.mmid.length < 12) {
        this.setState({ invalidMmid: true, error: true });
      } else {
        this.setState({ invalidMmid: false });
      }
    }

    if (value === "bta") {
      if (isNaN(Number(savObj.bta))) {
        this.setState({ invalidBta: true, error: true });
      } else if (savObj.bta.length < 10) {
        this.setState({ invalidBta: true, error: true });
      } else {
        this.setState({ invalidBta: false });
      }
    }

    // Central Card Delivery
    if (value === "ccdNumber") {
      if (isNaN(Number(savObj.ccdNumber))) {
        this.setState({ invalidccdNumber: true, error: true });
      } else if (savObj.ccdNumber.length < 15) {
        this.setState({ invalidccdNumber: true, error: true });
      } else {
        this.setState({ invalidccdNumber: false });
      }
    }

    // Central Statement Delivery
    if (value === "csdNumber") {
      if (isNaN(Number(savObj.csdNumber))) {
        this.setState({ invalidcsdNumber: true, error: true });
      } else if (savObj.csdNumber.length < 15) {
        this.setState({ invalidcsdNumber: true, error: true });
      } else {
        this.setState({ invalidcsdNumber: false });
      }
    }

    // Corporate Membership Rewards
    if (value === "corporateMembershipRewards") {
      if (isNaN(Number(savObj.corporateMembershipRewards))) {
        this.setState({ invalidcorporateMembershipRewards: true, error: true });
      } else if (savObj.corporateMembershipRewards.length < 15) {
        this.setState({ invalidcorporateMembershipRewards: true, error: true });
      } else {
        this.setState({ invalidcorporateMembershipRewards: false });
      }
    }
  };

  render() {
    const { t } = this.props;

    const {
      country,
      invalidCountry,
      corporateId,
      upload,
      selectedRoles,
      selectedFunctions,
      submit,
      idInvalid,
      accessesArray,
      invalidAccess,
      invalidAccessOptions,
      actionName,
      isWorkrole,
      isOnlineRole,
      isCorpRole,
      isVpaymentRole,
      savObj,
      invalidMmid,
      invalidBta,
      invalidccdNumber,
      invalidcsdNumber,
      invalidcorporateMembershipRewards,
      fileArr,
      outerCheckbox,
      innerCheckbox,
    } = this.state;

    let showUpload =
      (this.props.accessobj.country === t("access.INDIA") || upload) &&
      selectedRoles
        .map((item) => item.roleName)
        .indexOf(t("products.role-approver")) > -1
        ? true
        : false;

    let showVpayment =
      selectedFunctions
        .map((item) => item.functionName)
        .indexOf(t("products.functname9")) > -1
        ? true
        : false;

    let showExpressGo =
      selectedFunctions
        .map((item) => item.functionName)
        .indexOf(t("products.functname12")) > -1
        ? true
        : false;

    return (
      <>
        <div className="accessBox">
          <div className="accessCol">
            <h2 className="formSectionHeader">{t("access.forAccess")}</h2>
            <Hint className="pad-2-b">{t("access.accessInfoMsg")}</Hint>
            <div className="pad-2-b">
              <Label>{t("newuser.countryAccess")}</Label>
              <CountryDropdown
                country={country}
                handleCountrySelectChange={this.handleSelectChange}
                languageSelected={this.props.language}
              />
              {invalidCountry && (
                <Alert status="error">{t("access.countryValid")}</Alert>
              )}
            </div>

            <div className="inputCorporateIdWrapper">
              <Label>
                {country === t("access.UNITEDKINGDOM") || isSwedenNorway(country, t)
                   ? t("access.controlAccountNumberCid")
                   : t("access.corporateId")}
              </Label>
              <Input
                placeholder={
                  country === t("access.UNITEDKINGDOM") || isSwedenNorway(country, t)
                  ? t("access.controlAccountNumberCid")
                  : t("access.corporateId")
                }
                value={corporateId}
                onChange={(event) => {
                  this.updateCorporateId(event.target.value);
                }}
                onBlur={this.prefixCorporateId}
                maxLength={
                  country === t("access.JAPAN")
                    ? "15"
                    : country === t("access.UNITEDKINGDOM") ||
                      isSwedenNorway(country, t)
                      ? "15"
                      : "6"
                }
              />

              {country === t("access.JAPAN") ? (
                <Hint className="hint">{t("access.controlvalidjapa")}</Hint>
              ) : country === t("access.UNITEDKINGDOM") || isSwedenNorway(country, t) ? (
                <Hint className="hint">{t("access.controlAccountNumberCidHint")}</Hint>
              ) : (
                <Hint className="hint">{t("access.controlacnum")}</Hint>
              )}

              {submit &&
                (corporateId.replace(/\s+/g, "").length !== 15 ||
                  corporateId.replace(/[0-9]/g, "").length > 0) &&
                country !== t("access.JAPAN") &&
                country !== t("access.UNITEDKINGDOM") &&
                !isSwedenNorway(country, t) &&
                !corporateId.match(/^[0-9]*$/) && (
                  <Alert status="error">{t("access.controlvalid")} </Alert>
                )}

              {idInvalid &&
                country !== t("access.JAPAN") &&
                country !== t("access.UNITEDKINGDOM") &&
                !isSwedenNorway(country, t) && (
                  <Alert status="error">{t("access.controlvalid")} </Alert>
                )}

              {idInvalid && country === t("access.JAPAN") && (
                <Alert status="error">{t("access.controlvalidjapa")}</Alert>
              )}

              {idInvalid && country === t("access.UNITEDKINGDOM") && (
                <Alert status="error">{t("access.controlAccountNumberCidHint")}</Alert>
              )}

              {idInvalid && isSwedenNorway(country, t) && (
                <Alert status="error">{t("access.controlAccountNumberCidHint")}</Alert>
              )}

              <span className="inputCorporateIdTooltip">
                <Tooltip
                  id="tooltip-default-top"
                  triggerElement={
                    <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                  }
                  placement="top"
                >
                  {country === t("access.UNITEDKINGDOM") ? (
                    <div>{t("accessUk.corpIdInfo")}</div>
                  ) : (
                    <div>{t("access.corpIdInfo")}</div>
                  )}
                </Tooltip>
              </span>
            </div>
          </div>

          <div className="accessCol">
            {accessesArray.length > 0 && (
              <>
                <div className="functionLabelDiv">
                  <h3 className="formSectionHeader">{t("access.Functions")}</h3>
                  <div className="inputfunctionTooltip">
                    <Tooltip
                      id="tooltip-default-top"
                      triggerElement={
                        <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                      }
                      placement="left"
                    >
                      <div> {t("access.selectfn")}</div>
                    </Tooltip>
                  </div>
                  {invalidAccess && selectedFunctions.length === 0 && (
                    <Alert>{t("access.function-select")}</Alert>
                  )}
                  {invalidAccessOptions && (
                    <Alert>{t("access.radiobtns")}</Alert>
                  )}
                </div>
                <ul>
                  {accessesArray[0].functions.map((el, index) => {
                    let isChecked =
                      selectedFunctions
                        .map((item) => item.functionName)
                        .indexOf(el.functionName) > -1
                        ? true
                        : false;

                    return (
                      <div
                        className={isChecked ? "innerCheckboxWrapper" : null}
                      >
                        <label>
                          <input
                            name={el.functionName}
                            type="checkbox"
                            checked={isChecked ? true : false}
                            onChange={(event) => {
                              this.checkBoxHandler(event);
                            }}
                          />
                          <span>{el.functionName}</span>
                        </label>

                        {isChecked && (
                          <>
                            {this.props.modifyUser && (
                              <div className="innerRadioWrapper">
                                <RadioGroup
                                  onChange={(event) => {
                                    this.handleRadioClick(
                                      event,
                                      el.functionName
                                    );
                                  }}
                                >
                                  {!actionName.find(
                                    (f) => f.functionName === el.functionName
                                  ) && (
                                    <Alert
                                      status="error"
                                      className="rolesalert"
                                    >
                                      {t("access.rolesvalid")}
                                    </Alert>
                                  )}
                                  <div className="radioInline">
                                    <RadioButton
                                      id={`radioAdd-${index}`}
                                      label={t("access.add")}
                                      value={t("access.add")}
                                    />
                                  </div>
                                  <div className="radioInline">
                                    <RadioButton
                                      id={`radioDelete-${index}`}
                                      label={t("access.delete")}
                                      value={t("access.delete")}
                                    />
                                  </div>
                                </RadioGroup>
                              </div>
                            )}

                            <div className="roleCheckbox">
                              {el.functionName === t("products.functname10") &&
                                isWorkrole && (
                                  <Alert status="error" className="rolesalert">
                                    {t("access.role-select")}
                                  </Alert>
                                )}

                              {el.functionName === t("products.functname2") &&
                                isOnlineRole && (
                                  <Alert status="error" className="rolesalert">
                                    {t("access.role-select")}
                                  </Alert>
                                )}

                              {el.functionName === t("products.functname4") &&
                                isCorpRole && (
                                  <Alert status="error" className="rolesalert">
                                    {t("access.role-select")}
                                  </Alert>
                                )}

                              {el.functionName === t("products.functname9") &&
                                isVpaymentRole && (
                                  <Alert status="error" className="rolesalert">
                                    {t("access.role-select")}
                                  </Alert>
                                )}

                              {el.roles.map((rol) => {
                                let isSelected =
                                  selectedRoles
                                    .map((item) => item.roleName)
                                    .indexOf(rol.roleName) > -1
                                    ? true
                                    : false;

                                return (
                                  <label>
                                    {el.functionName ===
                                    t("products.functname4") ? (
                                      <>
                                        <input
                                          type="checkbox"
                                          name={rol.roleName}
                                          value={rol.roleName}
                                          checked={isSelected ? true : false}
                                          id={rol.roleName}
                                          onChange={(event) => {
                                            this.handleRoleClick(
                                              event,
                                              el.functionName
                                            );
                                          }}
                                        />
                                        {rol.roleName}
                                        <hr />

                                        {isSelected &&
                                          rol.roleName ===
                                            t("products.role-approver") && (
                                            <h5>{rol.message} </h5>
                                          )}
                                        {isSelected &&
                                          rol.roleName ===
                                            t("products.pafull") && (
                                            <h5>{rol.message}</h5>
                                          )}
                                      </>
                                    ) : (
                                      <>
                                        <input
                                          type="checkbox"
                                          name={rol.roleName}
                                          value={rol.roleName}
                                          checked={isSelected ? true : false}
                                          onChange={(event) => {
                                            this.handleRoleClick(
                                              event,
                                              el.functionName
                                            );
                                          }}
                                        />
                                        {rol.roleName}
                                        <hr />
                                        {rol.roleName ===
                                          t("products.role-approver") && (
                                          <h5>{el.message}</h5>
                                        )}
                                        {isSelected &&
                                          rol.roleName ===
                                            t("products.role-approver") && (
                                            <h5>{rol.message}</h5>
                                          )}
                                        {isSelected &&
                                          rol.roleName ===
                                            t("products.pafull") && (
                                            <h5>{rol.message}</h5>
                                          )}
                                      </>
                                    )}
                                  </label>
                                );
                              })}

                              {el.functionName === t("products.functname4") && (
                                <div className="inputCorporateIdWrapper">
                                  <Input
                                    placeholder={t("access.mmid")}
                                    maxLength="12"
                                    value={
                                      savObj.mmid ||
                                      this.functionSorting(
                                        t("products.functname4")
                                      )?.membershipRewardsAccountNumber
                                    }
                                    onChange={(event) => {
                                      this.updateSavobj(
                                        "mmid",
                                        event.target.value
                                      );
                                    }}
                                    onBlur={() => this.validateDetails("mmid")}
                                  />
                                  <Hint className="hint">
                                    {t("access.bcacmr")}
                                  </Hint>

                                  {invalidMmid && (
                                    <Alert status="error">
                                      {t("access.mmidvalid")}
                                    </Alert>
                                  )}
                                  <span className="cmrTooltip">
                                    <Tooltip
                                      id="tooltip-default-left"
                                      triggerElement={
                                        <TooltipButton
                                          icon={<GlyphInfo />}
                                          tabIndex="-1"
                                        />
                                      }
                                      placement="left"
                                    >
                                      {t("access.mmidaccount")}
                                    </Tooltip>
                                  </span>
                                </div>
                              )}

                              {el.functionName === t("products.functname5") && (
                                <div className="inputCorporateIdWrapper">
                                  <Hint className="hint">
                                    {t("access.enterbta")}
                                  </Hint>
                                  <Input
                                    placeholder={t("access.btanumber")}
                                    maxLength="10"
                                    value={
                                      savObj.bta ||
                                      this.functionSorting(
                                        t("products.functname5")
                                      )?.btaNumber
                                    }
                                    onChange={(event) => {
                                      this.updateSavobj(
                                        "bta",
                                        event.target.value
                                      );
                                    }}
                                    onBlur={() => this.validateDetails("bta")}
                                  />

                                  {invalidBta && (
                                    <Alert className="pad-1-t pad-1-b">
                                      {t("access.10bta")}
                                    </Alert>
                                  )}
                                  <span className="btaTooltip">
                                    <Tooltip
                                      id="tooltip-default-left"
                                      triggerElement={
                                        <TooltipButton
                                          icon={<GlyphInfo />}
                                          tabIndex="-1"
                                        />
                                      }
                                      placement="left"
                                    >
                                      {t("access.btatooltip")}
                                    </Tooltip>
                                  </span>
                                </div>
                              )}

                              {/* UK =  Corporate Online Payments Allocation */}
                              {el.functionName ===
                                t("ukFunction.function3") && (
                                <p className="legal-1 pad-1-b">
                                  {t("ukFunction.function3Info")}
                                </p>
                              )}
                              {/* UK = Central Card Delivery */}
                              {el.functionName ===
                                t("ukFunction.function4") && (
                                <>
                                  <p className="legal-1 pad-1-b">
                                    {t("ukFunction.function4Info")}
                                  </p>

                                  <Input
                                    maxLength="15"
                                    value={
                                      savObj.ccdNumber ||
                                      this.functionSorting(
                                        t("ukFunction.function4")
                                      )?.ccdNumber
                                    }
                                    onChange={(event) => {
                                      this.updateSavobj(
                                        "ccdNumber",
                                        event.target.value
                                      );
                                    }}
                                    onBlur={() =>
                                      this.validateDetails("ccdNumber")
                                    }
                                  />

                                  {invalidccdNumber && (
                                    <Alert className="pad-1-t pad-1-b">
                                      {t("ukFunction.function4Error")}
                                    </Alert>
                                  )}
                                </>
                              )}
                              {/* UK = Central Statement Delivery */}
                              {el.functionName ===
                                t("ukFunction.function5") && (
                                <div className="inputCorporateIdWrapper">
                                  <Hint className="legal-1 hint">
                                    {t("ukFunction.function5Info")}
                                  </Hint>

                                  <Input
                                    maxLength="15"
                                    value={
                                      savObj.csdNumber ||
                                      this.functionSorting(
                                        t("ukFunction.function5")
                                      )?.csdNumber
                                    }
                                    onChange={(event) => {
                                      this.updateSavobj(
                                        "csdNumber",
                                        event.target.value
                                      );
                                    }}
                                    onBlur={() =>
                                      this.validateDetails("csdNumber")
                                    }
                                  />

                                  {invalidcsdNumber && (
                                    <Alert className="pad-1-t pad-1-b">
                                      {t("ukFunction.function4Error")}
                                    </Alert>
                                  )}
                                </div>
                              )}
                              {/* UK =  Corporate Membership Rewards for UK */}
                              {el.functionName ===
                                t("ukFunction.function6") && (
                                <>
                                  <p className="legal-1 pad-1-b">
                                    {t("ukFunction.function6Info")}
                                  </p>

                                  <Input
                                    maxLength="15"
                                    value={
                                      savObj.corporateMembershipRewards ||
                                      this.functionSorting(
                                        t("ukFunction.function6")
                                      )?.corporateMembershipRewards
                                    }
                                    onChange={(event) => {
                                      this.updateSavobj(
                                        "corporateMembershipRewards",
                                        event.target.value
                                      );
                                    }}
                                    onBlur={() =>
                                      this.validateDetails(
                                        "corporateMembershipRewards"
                                      )
                                    }
                                  />

                                  {invalidcorporateMembershipRewards && (
                                    <Alert className="pad-1-t pad-1-b">
                                      {t("ukFunction.function4Error")}
                                    </Alert>
                                  )}
                                </>
                              )}
                              {/* UK =  Approve Cardmember Applications */}
                              {el.functionName ===
                                t("ukFunction.function7") && (
                                <p className="legal-1 pad-1-b">
                                  {t("ukFunction.function7Info")}
                                </p>
                              )}

                              {/* UK =  vPayment Net Service */}
                              {el.functionName ===
                                t("ukFunction.function10") && (
                                <p className="legal-1 pad-1-b">
                                  {t("ukFunction.function10Info")}
                                </p>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}
                </ul>
              </>
            )}
          </div>

          {showUpload && (
            <div className="uploadfilewrapper">
              <Upload
                getFile={(file) => this.getFile(file)}
                fileuploadded={
                  this.props.accessobj.country === t("access.INDIA")
                    ? this.props.accessobj.functions
                    : undefined
                }
                files={fileArr}
              ></Upload>
              {outerCheckbox === t("products.functname2") &&
                innerCheckbox === t("products.role-approver") &&
                selectedFunctions?.map((e, index) =>
                  e.roles.map(
                    (val) =>
                      fileArr.length === 0 &&
                      val?.files === undefined && (
                        <Alert status="error">Please upload file</Alert>
                      )
                  )
                )}
            </div>
          )}

          {(showVpayment || showExpressGo) && (
            <div className="VpaymentOuter">
              <PaymentForm
                t={t}
                vPayment={showVpayment}
                data={this.props.accessobj}
                go={showExpressGo}
                dataChange={(data) => {
                  this.setState({
                    savObj: {
                      paymentData: data,
                    },
                  });
                  this.setState({
                    invalidPaymentForm: !(data && data.completed),
                  });
                }}
              />
            </div>
          )}
        </div>

        <div className="accessbtnWrapper">
          <ButtonPrimary onClick={this.handleAddAccess} className="accessbtn">
            <span> {t("access.saveaccess")}</span>
          </ButtonPrimary>
        </div>
      </>
    );
  }
}

export default withTranslation("common")(AddAccess);
